import { Injectable } from '@angular/core';
import {
  FullscriptEmbedSessionRequest,
  FullscriptEmbedSessionResponse,
  FullscriptPatientLinkRequest,
  FullscriptStatus,
} from '@models';
import { Observable, of } from 'rxjs';
import { FullscriptService } from './fullscript.service';

@Injectable({ providedIn: 'root' })
export class FullscriptMockService implements FullscriptService {
  private connected = true;
  private linkedPatients = new Set<string>();

  getStatus(): Observable<FullscriptStatus> {
    return of({
      available: true,
      connected: this.connected,
      fullscriptUserType: 'clinic',
      clinicId: 'mock-clinic-id',
      scopes: [],
    });
  }

  getOAuthStartUrl(_returnTo: string): Observable<string> {
    return of('https://us.fullscript.com/oauth/mock-authorize');
  }

  getEmbedSession(
    req: FullscriptEmbedSessionRequest
  ): Observable<FullscriptEmbedSessionResponse> {
    const alreadyLinked = this.linkedPatients.has(req.patientId);
    return of({
      env: 'us.fullscript.com',
      publicKey: 'mock-public-key',
      secretToken: 'mock-secret-token',
      entrypoint: req.entrypoint ?? 'catalog',
      patient: {
        id: alreadyLinked ? 'fs-mock-patient-id' : null,
        firstName: 'Mock',
        lastName: 'Patient',
        email: 'mock@example.com',
        dateOfBirth: '1990-01-01',
        biologicalSex: 'male',
        mobileNumber: null,
      },
    });
  }

  linkPatient(req: FullscriptPatientLinkRequest): Observable<void> {
    this.linkedPatients.add(req.localPatientId);
    return of(void 0);
  }
}
